import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';

export enum OperationalNoteResourceType {
  provider = 'provider',
  patient = 'patient',
  appointment = 'appointment',
}

export enum OperationalNoteType {
  accountDeactivated = 'account_deactivated',
  collabAgreement = 'collab_agreement_review',
  contractIssue = 'contract_issue',
  ghosted = 'ghosted',
  notGoingLiveInState = 'not_going_live_in_state',
  onboardAssignee = 'onboard_assignee',
  poorDocumentationQuality = 'poor_documentation_quality',
  other = 'other',
}

export type ProviderOperationalNote = {
  id: string;
  content: string;
  authorId: string;
  assigneeId: string | null;
  resourceType: OperationalNoteResourceType;
  resourceId: string;
  noteType: OperationalNoteType;
  archivedAt: string | null;
  createdAt: string;
  assignedAt: string | null;
};

export type CreateProviderNoteBody = {
  content: string;
  noteType: OperationalNoteType;
  assigneeId?: string | null;
};

export type UpdateProviderNoteBody = Partial<Pick<CreateProviderNoteBody, 'noteType' | 'assigneeId'>>;

export const adminGetProviderOperationalNotes = (providerId: string) =>
  restClient.request<{ data: ProviderOperationalNote[] }>(`/api/v1/admin/providers/${providerId}/operational_notes`);

export const adminGetAssignedNotes = () =>
  restClient.request<{ data: ProviderOperationalNote[] }>('/api/v1/admin/assigned_notes');

export const adminCreateProviderOperationalNote = (providerId: string, body: CreateProviderNoteBody) => {
  const data = { note_type: body.noteType, content: body.content, assignee_id: body.assigneeId };

  return restClient.request<ProviderOperationalNote>(`/api/v1/admin/providers/${providerId}/operational_notes`, {
    method: 'POST',
    data,
  });
};

export const adminArchiveProviderOperationalNote = (providerId: string, noteId: string) =>
  restClient.request(`/api/v1/admin/providers/${providerId}/operational_notes/${noteId}/archive`, {
    method: 'POST',
  });

export const adminUnarchiveProviderOperationalNote = (providerId: string, noteId: string) =>
  restClient.request(`/api/v1/admin/providers/${providerId}/operational_notes/${noteId}/unarchive`, {
    method: 'POST',
  });

export const adminUpdateOperationalNote = (providerId: string, noteId: string, body: UpdateProviderNoteBody) => {
  return restClient.request(`/api/v1/admin/providers/${providerId}/operational_notes/${noteId}`, {
    method: 'PATCH',
    data: snakecaseKeys(body),
  });
};
